const myProfile = (query) => {
	return `query myProfile {
		myProfile{
			${query}
		}
	}`;
}

export default myProfile;
